module.exports = __webpack_public_path__ + "img/组 88@3x.1ac6ec65.png";